export default __webpack_public_path__ + "static/media/gibiondi.5ce2c330.jpg";